import { useMemo } from "react";

import { formatCurrency } from "@covertree/utils";
import { Grid, Typography } from "@mui/material";

interface Props {
  id: string;
  title: string;
  value: number | string;
}

export function SummaryRow({ id, title, value }: Props) {
  const formattedValue = useMemo(
    () => (typeof value === "number" ? formatCurrency(value) : value),
    [value]
  );

  return (
    <Grid id={`${id}-container`} container justifyContent="space-between">
      <Grid item>
        <Typography id={`${id}-container`} variant="h6">
          {title}
        </Typography>
      </Grid>
      <Grid>
        <Typography id={`${id}-container`} variant="h6" color="secondary">
          {formattedValue}
        </Typography>
      </Grid>
    </Grid>
  );
}
